import { useCallback, useEffect, useState } from 'react';
import { useFormState } from 'react-final-form';
import { useLazyQuery } from '@apollo/client';
import { FORM_VALUES } from '../utils/helpers/constants';
import { getLandmarksQuery } from '../api/queries';
import { LandmarksQuery } from '../graphql/graphql';
import { Coordinates } from '../providers/GoogleMapsProvider/types';

export const useLandmarks = (
  coordinates: Coordinates,
  initialLocation: Coordinates
) => {
  const { values } = useFormState();
  const [locations, setLocations] = useState<LandmarksQuery['landmarks']>([]);

  const landmarksQueryVariables = {
    cityId: values[FORM_VALUES.cityId],
    latitude: coordinates?.lat,
    longitude: coordinates?.lng
  };

  const [getLandmarks] = useLazyQuery<LandmarksQuery>(getLandmarksQuery, {
    onCompleted: data => setLocations(data.landmarks),
    variables: landmarksQueryVariables
  });

  const handleLocationDelete = useCallback(
    id => {
      const updatedLocations =
        locations?.filter(location => location.id !== id) || [];
      setLocations(updatedLocations);
    },
    [locations]
  );

  useEffect(() => {
    getLandmarks({
      variables: {
        cityId: values[FORM_VALUES.cityId],
        latitude: coordinates?.lat,
        longitude: coordinates?.lng
      }
    });
  }, [initialLocation]);

  return {
    locations,
    getLandmarks,
    handleLocationDelete
  };
};
